export const Verdict = ({ session, testid }) => {
  const st = session?.evaluation_status;
  if (session?.status === "in_progress") return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-blue-400 bg-blue-500/10">IN PROGRESS</span>;
  if (session?.status === "completed" && !st) return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-slate-300 bg-slate-800">SUBMITTED</span>;
  if (st === "pending") return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-amber-500 bg-amber-500/10 animate-pulse">EVALUATING</span>;
  if (st === "failed") return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-slate-400 bg-slate-800">EVAL ERROR</span>;
  if (session?.verdict === "PASS") return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-emerald-500 bg-emerald-500/10">PASSED</span>;
  if (session?.verdict === "FAIL") return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-rose-500 bg-rose-500/10">FAILED</span>;
  return <span data-testid={testid} className="font-mono text-[11px] tracking-wider px-2 py-1 text-slate-500 bg-slate-800">-</span>;
};

export const StatCard = ({ label, value, accent = "text-white", testid }) => (
  <div className="bg-slate-900 border border-slate-800 p-6 transition-transform hover:-translate-y-1" data-testid={testid}>
    <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-slate-500">{label}</p>
    <p className={`font-cabinet font-extrabold text-4xl mt-3 ${accent}`}>{value}</p>
  </div>
);

export const PageTitle = ({ kicker, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
    <div>
      {kicker && <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-400 mb-3">{kicker}</p>}
      <h1 className="font-cabinet font-extrabold text-white text-4xl sm:text-5xl tracking-tight">{title}</h1>
    </div>
    {children}
  </div>
);
